import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-reset-password-dialog',
  templateUrl: './reset-password-dialog.component.html',
  styleUrls: ['./reset-password-dialog.component.scss']
})
export class ResetPasswordDialogComponent {


  resetForm!: FormGroup;
  email: string = '';
  showPassword = false;
  showConfirmPassword = false;



  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _auth:AuthService,
    private _common:CommonService
  ) {
    // Receive email via MAT_DIALOG_DATA from the caller
    this.email = data?.email || '';
  }

  ngOnInit(): void {
    this.resetForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(6),
           Validators.minLength(8),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).+$/),]],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: this.passwordMatchValidator,
      }
    );
  }
  togglePasswordVisibility(field: 'password' | 'confirmPassword'): void {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  passwordMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit(): void {
   
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
     
      return;
    }

    const payload = {
      email: this.email,
      newPassword: this.resetForm.value.password,
      conformPassword: this.resetForm.value.confirmPassword,
    };
   

     this._auth.reset(payload).subscribe({
    next: () => {
      this._common.openSnackBar('Reset Password successfully!');
      this.close();
    },
   error: (err) => {
  console.error('Error from observable:', err);
  this._common.openSnackBarError(err.message || 'Failed to reset password');
}
  });

  }

  resetFormFields(): void {
    this.resetForm.reset();
    this.showPassword = false;
    this.showConfirmPassword = false;
  }

  close(){
  
  this.dialog.closeAll();

  }



}
